
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


const STATUS_DICT = {
0: {
className: '',
text: '未受理'
},
5: {
className: 'no-pass',
text: '已受理'
},
15: {
className: 'passed',
text: '已办结反馈'
},
14: {
className: 'passed',
text: '已办结反馈'
},
12: {
className: 'waiting',
text: '正在调查'
},
10: {
className: 'waiting',
text: '正在调查'
}
}
export default {
components: {
Group,
Cell,
CellBox,
Datetime,
XInput,
XButton
},
data () {
return {
vioAddress: '',
vioTime: '',
remark: '',
vioTypeCn: '',
vioLicensePlate: '',
xzgh: '',
vioDescribe: '',
result: '',
zt: '-1',
showResult: false
}
},
computed: {
statusClass: function () {
return STATUS_DICT[this.zt] && STATUS_DICT[this.zt].className
? STATUS_DICT[this.zt].className
: 'waiting'
},
statusText: function () {
return STATUS_DICT[this.zt].text
}
},
created () {
const str = sessionStorage.getItem('reportItem') || '{}'
const reportItem = JSON.parse(str)
this.remark = reportItem.remark || ''
this.vioAddress = reportItem.vioAddress || ''
this.vioTime = reportItem.vioTime ? reportItem.vioTime + '' : ''
this.vioTypeCn = reportItem.vioTypeCn || ''
this.vioLicensePlate = reportItem.vioLicensePlate || ''
this.areaCodeCn = reportItem.areaCodeCn || ''
this.result = reportItem.result || ''
this.vioDescribe = reportItem.vioDescribe || ''
this.zt = reportItem.status || '0'

this.showResult = this.checkIsFutureDate(this.vioTime)
},
methods: {
checkIsFutureDate (timeStr) {


const dateObj = new Date(timeStr)
let timestamp = dateObj.getTime()

const today = new Date('2026-03-06')
today.setHours(0, 0, 0, 0) 
const todayTimestamp = today.getTime()

console.log('违法时间戳:', timestamp, '今天时间戳:', todayTimestamp, '是否今天之后:', timestamp >= todayTimestamp)

return timestamp >= todayTimestamp
},
goback () {
sessionStorage.setItem('currentType', 1)

this.$router.replace({ path: '/vioReportIndex' })
}
}
}



// WEBPACK FOOTER //
// ./src/views/vioReport/ReportDetail.vue